import { Fragment, Ref } from 'preact'
import { CSSProperties, forwardRef } from 'preact/compat'
import { useState, useEffect } from 'preact/hooks'
import i18n from 'core/services/i18n'
import { ElementReminderOptions } from 'core/types/element/element_reminder'
import CheckMark from '../common/CheckMark'
import CrossIcon from '../common/CrossIcon'
import PhoneComponent from './PhoneComponent'

const styles = {
  width: '300px',
  boxShadow: '0 5px 11px 0 rgba(0, 0, 0, 0.1)',
  border: '1px solid rgb(231, 231, 244)',
  borderRadius: '10px',
  background: '#ffffff',
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  padding: '7px 15px'
}

const buttonStyles = {
  width: '27px',
  height: '25px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '5px',
  marginLeft: '5px'
}

const successMessageStyles = {
  width: '100%',
  fontSize: '14px'
}

type Props = {
  options: ElementReminderOptions['phone']
  onSubmit: () => Promise<void> | undefined
  onClose: () => void
  styles: CSSProperties
}

const PhoneForm = forwardRef((props: Props, ref: Ref<HTMLDivElement>) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const submitButtonStyles = {
    ...buttonStyles,
    backgroundColor: `rgba(${props.options?.submit_button?.bg_color})`
  }
  const closeButtonStyles = {
    ...buttonStyles,
    backgroundColor: `rgba(${props.options?.close_button?.bg_color})`
  }

  const submit = () => {
    props.onSubmit()?.then(() => setShowSuccessMessage(true))
  }

  useEffect(() => {
    if (!showSuccessMessage) return

    const timer = setTimeout(() => {
      setShowSuccessMessage(false)
      props.onClose()
    }, 5000)

    return () => clearTimeout(timer)
  }, [showSuccessMessage])

  return (
    <div
      ref={ref}
      className="wf_reset wf_phone"
      style={{ ...styles, ...props.styles }}
      onClick={e => e.stopPropagation()}
    >
      {showSuccessMessage ? (
        <div
          style={{
            ...successMessageStyles,
            color: `rgba(${props.options?.submit_button?.bg_color})`
          }}
        >
          {i18n.t('layout.cos_button.update_phone_number_message')}
        </div>
      ) : (
        <Fragment>
          <PhoneComponent placeholder={i18n.t('layout.cos_button.phone')} options={props.options} />
          <div onClick={submit} style={submitButtonStyles}>
            <CheckMark color={`rgba(${props.options?.submit_button?.icon_color})`} />
          </div>
          <div onClick={props.onClose} style={closeButtonStyles}>
            <CrossIcon fill={`rgba(${props.options?.close_button?.icon_color})`} />
          </div>
        </Fragment>
      )}
    </div>
  )
})

export default PhoneForm
